import script from "./_job-deck.vue?vue&type=script&setup=true&lang=js"
export * from "./_job-deck.vue?vue&type=script&setup=true&lang=js"

import "./_job-deck.vue?vue&type=style&index=0&id=c414da52&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c414da52"]])

export default __exports__